import { useTranslation } from "react-i18next";
import { PageHeader } from "../components/ui-blocks";
import { IMAGES } from "../lib/content";

export default function Sectors() {
  const { t } = useTranslation();
  const sectors = t("data.sectors", { returnObjects: true });

  return (
    <>
      <PageHeader
        testId="sectors-header"
        overline={t("sectors.headerOverline")}
        title={t("sectors.headerTitle")}
        lead={t("sectors.headerLead")}
      />

      <section className="py-10 md:py-14" data-testid="sectors-grid">
        <div className="container-mtbl">
          {sectors.map((sec, i) => {
            const reverse = i % 2 === 1;
            return (
              <div
                key={sec.title}
                data-testid={`sectors-item-${i}`}
                className="grid lg:grid-cols-12 gap-10 lg:gap-16 items-center py-12 md:py-16 border-b border-slate-200 last:border-b-0"
              >
                <div className={`lg:col-span-7 ${reverse ? "lg:order-2" : ""}`}>
                  <p className="overline">
                    {t("sectors.itemLabel")} · 0{i + 1}
                  </p>
                  <h2 className="mt-4 text-[#0B1A3D] text-3xl md:text-4xl lg:text-5xl font-semibold tracking-tight leading-tight">
                    {sec.title}
                  </h2>
                  <p className="mt-6 text-slate-600 text-base md:text-lg leading-relaxed max-w-xl">
                    {sec.body}
                  </p>
                </div>
                <div className={`lg:col-span-5 ${reverse ? "lg:order-1" : ""}`}>
                  <div className="rounded-2xl overflow-hidden border border-slate-200 shadow-[0_14px_40px_rgba(11,26,61,0.10)]">
                    <img
                      src={IMAGES[sec.img]}
                      alt={sec.title}
                      className="w-full h-[280px] md:h-[320px] lg:h-[360px] object-cover"
                    />
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </section>

      <section
        data-testid="sectors-note"
        className="section-pad bg-paper border-t border-slate-200"
      >
        <div className="container-mtbl max-w-4xl">
          <p className="overline mb-6">{t("sectors.noteOverline")}</p>
          <p className="text-[#0B1A3D] text-xl md:text-2xl font-semibold tracking-tight leading-snug">
            {t("sectors.noteTitle")}
          </p>
          <p className="mt-6 text-slate-600 leading-relaxed">
            {t("sectors.noteBody")}
          </p>
        </div>
      </section>
    </>
  );
}
